import { useContext, useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import ModalSmall from "../../../../components/ModalSmall";
import { SetChangePassword } from "../../../../../context/types";
import {
  IChangePasswordActionData,
  ICountry,
  IExpiredPasswordActionData,
  IForgotPasswordParams,
} from "../../../../../utils/types";
import { useLocation, useNavigate } from "react-router-dom";
import {
  getObjectFromIForgotPasswordParams,
} from "../../LoginUtils";
import {
  ChangePasswordAction,
  ExpiredPasswordAction,
  ForgotPasswordAction,
} from "../../../../../services/UserAuthService";
import { getAccessTokenLocalStorage } from "../../../../../context/utils";
import { UserPreferenceContext } from "../../../../../context/UserPreferenceContext";
import { usePreference } from "../../../../../context/usePreference";
import logoSmall from "../../../../../assets/custom/classic/logo_login_small.svg";
import "../../../stylePage.css";

const ChangePassword = ({ countries }: { countries: ICountry[] }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const user = usePreference();
  const [changePass, setChangePass] = useState<SetChangePassword>({
    CurrentPassword: "",
    NewPassword: "",
    NewConfirmPassword: "",
  } as SetChangePassword);

  const [loading, setLoading] = useState<boolean>(false);


  const [loaded, setLoaded] = useState<boolean>(false);



  const [forgotPasswordParams, setForgotPasswordParams] =
    useState<IForgotPasswordParams[]>();
  const [isActionPathForgotPassword, setIsActionPathForgotPassword] =
    useState<boolean>(false);

  const [error, setError] = useState<boolean>(false);
  const [msgError, setMsgError] = useState<string>("");
  const [info, setInfo] = useState<boolean>(false);
  const [msgInfo, setMsgInfo] = useState<string>("");
  const [passExpiringAlert, setPassExpiringAlert] =
    useState<boolean>(false);

  const location = useLocation();
  let stateRedirectRef: any;
  let stateErrorRef: string;
  let stateUsername: string;
  let stateCountryId: number;
  if (location?.state) {

    stateErrorRef = location?.state.error ?? null;
    stateUsername = location?.state.username ?? null;
    stateCountryId = location?.state.countryId ?? null;

    const { stateRedirect } = location?.state ?? null;
    stateRedirectRef = stateRedirect ?? null;
  }
  //Context
  const { userAuthenticated, doUserPreference } = useContext(UserPreferenceContext);
  useEffect(() => {
    handleLoadChangePasswordForm();
  });
  async function handleLoadChangePasswordForm() {

    if (user?.userPreference?.CodigoRetorno === 11 && !passExpiringAlert) {
      localStorage.setItem('passwordChangeRedirected', 'true');
      setMsgInfo(user?.userPreference?.MessageRetorno ?? "");
      setInfo(true);
      setPassExpiringAlert(true);
    }
    if (stateErrorRef && !loaded) {
      setMsgError(stateErrorRef);
      setError(true);
      setLoaded(true);
      setLoading(false)
    }

    setForgotPasswordParams(
      stateRedirectRef?.urlParamForgotPassword as IForgotPasswordParams[]
    );
    if (stateRedirectRef?.actionPath === "forgotPassword") {
      setIsActionPathForgotPassword(true);
    }
  }
  async function handleSend() {
    setLoading(true)
    setMsgError("");
    const tokenObject = getObjectFromIForgotPasswordParams(
      forgotPasswordParams,
      "token"
    );
    const languageObject = getObjectFromIForgotPasswordParams(
      forgotPasswordParams,
      "language"
    );

    let changePasswordActionData: any
    if (stateErrorRef) {
      const changePasswordAD: IExpiredPasswordActionData = {
        UserName: stateUsername,
        CountryId: stateCountryId,
        Password: changePass.CurrentPassword,
        NewPassword: changePass.NewPassword,
        ConfirmationPassword: changePass.NewConfirmPassword,
      };
      changePasswordActionData = changePasswordAD;



    } else {
      const changePasswordAD: IChangePasswordActionData = {
        oldPassword: changePass.CurrentPassword,
        newPassword: changePass.NewPassword,
        newConfirmPassword: changePass.NewConfirmPassword,
        token: tokenObject?.value ?? getAccessTokenLocalStorage(),
        language: languageObject?.value ?? "pt-BR",
        countryId: user?.userPreference?.Country?.CountryID ?? 1,
      };
      changePasswordActionData = changePasswordAD;
    }




    if (stateErrorRef) {
      handleExpiredPassword(changePasswordActionData);
    } else if (userAuthenticated && getAccessTokenLocalStorage()) {
      handleChangePassword(changePasswordActionData);
    } else {
      handleForgotPassword(changePasswordActionData);
    }
  }

  async function cancelChangePassword() {
    navigate("/");
  }

  async function handleChangePassword(
    changePasswordActionData: IChangePasswordActionData
  ) {
    let success = await ChangePasswordAction(changePasswordActionData, user.userPreference)
      .then((response) => {
        if (response?.data?.Code > 0) {
          setMsgError(response?.data?.Message);
          setError(true);
          setLoading(false)
          return false;
        } else {
          localStorage.removeItem('passwordChangeRedirected');
          return true
        }
      })
      .catch((err) => {
        setMsgError(err?.response?.data?.Message ?? err?.message);
        setError(true);
        setLoading(false)
        return false;
      });
    if (success) {
      setMsgError("");
      await doUserPreference();
      setTimeout(() => navigate("/"), 1000);
    }

  }

  async function handleExpiredPassword(
    changePasswordActionData: IExpiredPasswordActionData
  ) {
    await ExpiredPasswordAction(changePasswordActionData)
      .then((response) => {
        if (response?.data?.Code > 0) {
          setMsgError(response?.data?.Message);
          setError(true);
          setLoading(false)
        } else {
          setTimeout(() => navigate("/"), 5000);
        }
      })
      .catch((err) => {
        setMsgError(err?.response?.data?.Message ?? err?.message);
        setError(true);
        setLoading(false)
      });
  }

  async function handleForgotPassword(
    changePasswordActionData: IChangePasswordActionData
  ) {
    await ForgotPasswordAction(changePasswordActionData)
      .then((response) => {

        if (response?.data?.Code > 0) {
          setMsgError(response?.data?.Message);
          setError(true);
          setLoading(false)
        } else {
          setTimeout(() => navigate("/"), 5000);
        }
      })
      .catch((err) => {
        setMsgError(err?.response?.data?.Message ?? err?.message);
        setError(true);
        setLoading(false)
      });
  }
  return (
    <>
      <div className="login-container change-password-page">
        <div className="login-form-wrapper">
          <div className="login-form-card">
            {/* Logo e Header */}
            <div className="login-form-header">
              <img src={logoSmall} alt="IBOPE" className="login-logo" />
              <h1 className="login-title">{t("password.changePassword")}</h1>
             
            </div>

            <form className="login-form">
              {/* Current Password - apenas se não for forgot password */}
              {!isActionPathForgotPassword && (
                <div className="login-input-group">
                 
                  <input
                    id="currentPassword"
                    data-testid="currentPassword"
                    className="loginInput"
                    placeholder={t("password.currentPassword")}
                    type="password"
                    value={changePass.CurrentPassword}
                    onChange={(e) =>
                      setChangePass((prev) => ({
                        ...prev,
                        CurrentPassword: e.target.value,
                      }))
                    }
                  />
                </div>
              )}

              {/* New Password */}
              <div className="login-input-group">
                
                <input
                  id="newPassword"
                  data-testid="newPassword"
                  className="loginInput"
                  placeholder={t("password.newPassword")}
                  type="password"
                  value={changePass.NewPassword}
                  onChange={(e) =>
                    setChangePass((prev) => ({
                      ...prev,
                      NewPassword: e.target.value,
                    }))
                  }
                  autoComplete="off"
                />
              </div>

              {/* Confirm New Password */}
              <div className="login-input-group">
                
                <input
                  id="confirmNewPassword"
                  data-testid="confirmNewPassword"
                  className="loginInput"
                  placeholder={t("password.confirmNewPassword")}
                  type="password"
                  value={changePass.NewConfirmPassword}
                  onChange={(e) =>
                    setChangePass((prev) => ({
                      ...prev,
                      NewConfirmPassword: e.target.value,
                    }))
                  }
                />
              </div>

              {/* Password Requirements */}
              <div className="password-requirements">
                <p className="requirements-title">{t("password.prerequisite")}</p>
                <ul className="requirements-list">
                  <li>{t("password.lowercaseLetter")}</li>
                  <li>{t("password.upercaseLetter")}</li>
                  <li>{t("password.number")}</li>
                  <li>{t("password.symbol")}</li>
                  <li>{t("password.character")}</li>
                  <li>{t("password.lastPasswords")}</li>
                </ul>
              </div>

              {/* Botões */}
              <div className="forgot-buttons-row">
                <Button
                  id="send"
                  data-testid="send"
                  className="button"
                  onClick={handleSend}
                  disabled={loading}
                >
                  {loading ? t("login.submit.loading") || "Sending..." : t("password.submit.send")}
                </Button>
                <Button
                  id="cancel"
                  data-testid="cancel"
                  variant="secondary"
                  className="btn-secondary"
                  onClick={() => cancelChangePassword()}
                  disabled={loading}
                >
                  {t("password.cancel")}
                </Button>
              </div>
            </form>
          </div>
        </div>
      </div>

      <ModalSmall
        showModal={error}
        setShowModal={setError}
        title={t("password.submit.errorTitle")}
        text={msgError}
        type="modal-danger"
      />
      <ModalSmall
        showModal={info}
        setShowModal={setInfo}
        title={t("password.submit.WarnTitle")}
        text={msgInfo}
        type="modal-warn"
      />
    </>
  );
};

export default ChangePassword;
